import Choices from 'choices.js';

const selects = document.querySelectorAll('.js--choices');
const selectsChoice = document.querySelector('.js--choices');

if (selects.length) {
  window.choicesSelects = [];
  window.choicesData = {};

  selects.forEach((select, index) => {
    window.choicesData[index] = Array.from(select.options).map(option => ({
      value: option.value,
      label: option.text,
      selected: option.selected
    }));

    window.choicesSelects.push(new Choices(select, {
      removeItemButton: false,
      classNames: {
        containerInner: 'select__choices_inner',
        containerOuter: 'choices form-control',
      },
      allowHTML: true,
      shouldSort: false,
      searchResultLimit: 100,
      itemSelectText: "",
      noResultsText: 'Нічого не знайдено',
      searchFields: ['label'],
      fuseOptions: {
        threshold: 0,
      },
    }));
  });

  document.querySelector('form').addEventListener('reset', function () {
    setTimeout(() => {
      window.choicesSelects.forEach((choice, index) => {
        choice.clearChoices();
        choice.setChoices(window.choicesData[index], 'value', 'label', true);
      });
    }, 10);
  });
}
window.Choices = Choices;


